import React from "react";
import "./NotificationButton.css";
import { Button } from "@mui/material";
import NotificationsIcon from '@mui/icons-material/Notifications';

/**
 * A notification button component for the header that displays a notifications icon.
 * The button can trigger a dropdown menu for notifications (functionality to be implemented).
 * 
 * @component
 * @example
 * import NotificationButton from "../../Components/NotificationButton/NotificationButton";
 * <NotificationButton />
 * @returns {React.Fragment} The rendered notification button component.
 */
function NotificationButton({}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  /**
   * Handles the click event to open or close the notifications menu.
   * 
   * @param {Event} event - The click event.
   */
  const onClickMenuHandler = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  /**
   * Handles closing the notifications menu.
   */
  const onCloseMenuHandler = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button id="notificationButton" onClick={onCloseMenuHandler}>
        <NotificationsIcon
          id="notificationButtonIcon"
          size="medium"
          edge="end"
          color="inherit"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          aria-label="header_menu"
          onClick={onClickMenuHandler}
          sx={{marginLeft: "auto"}}
        >
      </NotificationsIcon>
      </Button>
    </>
  );
}

export default NotificationButton;
